import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../USER/Auth/AuthContext';
import { supabase } from '../../supabaseClient';
import SupportModal from './SupportModal';
import NotificationBell from './NotificationBell';
import { getDriverWallet } from '../DB/supabaseServices';
import HeaderLogo from './header/HeaderLogo';
import HeaderWalletBadge from './header/HeaderWalletBadge';
import HeaderUserMenu from './header/HeaderUserMenu';
import AppSidebar from './AppSidebar';
import './Header.css';

const Header = () => {
  const authContext = useAuth();
  const location = useLocation();
  const [showHelp, setShowHelp] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [walletBalance, setWalletBalance] = useState(null);

  // Close sidebar automatically on route change
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  // Fetch wallet balance for drivers
  useEffect(() => {
    if (!authContext.currentUser || !authContext.isDriver) {
      setWalletBalance(null);
      return;
    }

    const fetchBalance = async () => {
      try {
        const data = await getDriverWallet(authContext.currentUser.id);
        setWalletBalance(data?.balance ?? 0);
      } catch (err) {
        console.warn('Header: Error fetching wallet balance:', err);
        setWalletBalance(0);
      }
    };

    fetchBalance();
    const interval = setInterval(fetchBalance, 60000);
    return () => clearInterval(interval);
  }, [authContext.currentUser, authContext.isDriver]);

  const handleLogout = async () => {
    setSidebarOpen(false);
    if (authContext.logout) {
      await authContext.logout();
    } else {
      await supabase.auth.signOut();
      window.location.href = '/';
    }
  };

  const handleToggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <>
      <header className="app-header px-3 py-1 d-flex align-items-center justify-content-between">
        <HeaderLogo
          onToggleSidebar={handleToggleSidebar}
          isSidebarOpen={sidebarOpen}
        />

        <div className="header-right d-flex align-items-center gap-2">
          {authContext.currentUser && (
            <>
              {authContext.isDriver && walletBalance !== null && (
                <HeaderWalletBadge balance={walletBalance} />
              )}
              <NotificationBell />
              <HeaderUserMenu onOpenHelp={() => setShowHelp(true)} onLogout={handleLogout} />
            </>
          )}
        </div>

        <SupportModal show={showHelp} onHide={() => setShowHelp(false)} />
      </header>

      <AppSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        onLogout={handleLogout}
        onOpenHelp={() => setShowHelp(true)}
      />
    </>
  );
};

export default Header;
